import React, { useState, useContext } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";

import { demoContext } from "../../../../shared/store/contexts";

import { H3, P, H1, H5, H6 } from "../../../atoms/Texts";
import { OutlineButton, Badge } from "../../../atoms/Buttons";
import notSearchedImg from "../../../../assets/images/Curly Arrow.svg";
import * as Icon from "react-feather";

const ViewInitiativeReferral = () => {
  const { allInitiativeReferrals } = useContext(demoContext);
  const { id, referralId } = useParams();
  const [badgeStatusColor, setBadgeStatusColor] = useState({});

  const referral = allInitiativeReferrals?.find((item) => item.id === referralId);

  React.useEffect(() => {
    switch (true) {
      case referral?.status === "rejected":
        setBadgeStatusColor({
          bgColor: "#FDD2DC",
          textColor: "#DF0303",
        });
        break;

      case referral?.status === "approved":
        setBadgeStatusColor({
          bgColor: "#ECFDF3",
          textColor: "#167C3C",
        });
        break;

      default:
        setBadgeStatusColor({
          bgColor: "#EDEBFF",
          textColor: "#442ED0",
        });
        break;
    }

    return () => {
      setBadgeStatusColor({});
    };
  }, []);

  return (
    <div className="flex flex-col w-full">
      <section
        style={{
          background: "#f8f6fe",
        }}
        className="pt-16 pb-4 lg:px-6 xl:px-10 "
      >
        <div className="flex justify-between items-center">
          <div className="flex-1">
            <H1 fontSize="26px" color="#22202D" className="">
              Referral Information
            </H1>

            <div
              style={{
                width: "fit-content",
              }}
              className="mt-2"
            >
              <P fontSize="12px" color="#828282">
                Referral Information
              </P>
            </div>
          </div>
        </div>

        <Link to={`/dashboard/organization/${id}/initiatives`}>
          <div
            className="mt-10 flex items-center cursor-pointer"
            style={{
              width: "fit-content",
            }}
          >
            <Icon.ChevronLeft size={14} color="#7D7B96" className="mr-2" />
            <P color="#1E202A" fontSize="14px" smallSize="14px">
              Back to Initiatives
            </P>
          </div>
        </Link>
      </section>

      <div className="organization-container pb-10 flex-grow flex flex-col mt-6">
        <div>
          <div className="py-8">
            {referral ? (
              <div className="lg:px-10">
                <section className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  <article className="flex items-center gap-x-8 bg-white shadow-sm p-6">
                    <div className="h-20 w-20 bg-gray-200 rounded-full flex items-center justify-center font-bold">{`${referral?.user?.firstName?.[0]} ${referral?.user?.lastName?.[0]}`}</div>

                    <div className="">
                      <H6>
                        {referral?.user?.firstName} {""}
                        {referral?.user?.lastName}
                      </H6>
                      <div className="flex flex-col md:flex-row gap-4">
                        <P className="underline"> {referral?.user?.email}</P>
                        <P className="underline"> {referral?.user?.phone}</P>
                      </div>

                      <P> {referral?.user?.updated_at}</P>
                    </div>
                  </article>

                  <article className=" bg-white shadow-sm p-6">
                    <H6 className="block">Status</H6>

                    <Badge
                      className="capitalize mt-6"
                      fontFamily="poppins"
                      fontSize="12px"
                      bg={badgeStatusColor.bgColor}
                      color={badgeStatusColor.textColor}
                      fontWeight="font-normal"
                      p="4px 22px"
                    >
                      {referral?.status}
                    </Badge>
                  </article>
                </section>

                <section className="mt-6">
                  <div className="flex justify-between items-center">
                    <H3>Background</H3>

                    <div className="flex items-center gap-x-4">
                      <div>Save as pdf</div>
                      <div>Print</div>
                    </div>
                  </div>

                  <div className="bg-white grid grid-cols-1 lg:grid-cols-2 gap-8 mt-4 py-6 px-8">
                    <div>
                      <H5 className="border-b border-gray-300 py-1">Gender</H5>
                      <P className="py-1">{referral?.user?.gender || ""}</P>
                    </div>

                    <div>
                      <H5 className="border-b border-gray-300  py-1">Age</H5>
                      <P className="py-1">{referral?.user?.age || ""}</P>
                    </div>

                    <div>
                      <H5 className="border-b border-gray-300 py-1">Household</H5>
                      <P className="py-1">{referral?.user?.household || ""}</P>
                    </div>

                    <div>
                      <H5 className="border-b border-gray-300 py-1">Income</H5>
                      <P className="py-1">{referral?.user?.incomeLevel || ""}</P>
                    </div>

                    <div>
                      <H5 className="border-b border-gray-300  py-1">Employment</H5>
                      <P className="py-1">
                        {referral?.user?.employmentStatus || ""}
                      </P>
                    </div>

                    <div>
                      <H5 className="border-b border-gray-300  py-1">Housing</H5>
                      <P className="py-1">{referral?.user?.housingStatus || ""}</P>
                    </div>

                    <div>
                      <H5 className="border-b border-gray-300  py-1">Insurance</H5>
                      <P className="py-1">{referral?.user?.insurance || ""}</P>
                    </div>

                    <div>
                      <H5
                        fontWeight="400"
                        className="border-b border-gray-300  py-1 font-normal"
                      >
                        Justice Involvement
                      </H5>
                      <P className="py-1">
                        {referral?.user?.justice_involvement || ""}
                      </P>
                    </div>
                  </div>
                </section>
              </div>
            ) : (
              <section>
                <div className="flex flex-col items-center flex-grow justify-center">
                  <img src={notSearchedImg} alt="" className="" />
                  <H3
                    color="#22202D"
                    className="mt-6"
                    data-testid="eligibility-text"
                  >
                    You’re not part of any initiative yet
                  </H3>
                  <P
                    fontSize="16px"
                    color="#7D7B96"
                    className="mt-3 mb-0 text-center"
                  >
                    Search for the initiative to join or create an initiative
                  </P>
                </div>
                <div className="text-center mt-4">
                  <Link to={`/dashboard/organization/${id}/initiatives/add`}>
                    <OutlineButton color="#442ED0">Initiative Request</OutlineButton>
                  </Link>
                </div>
              </section>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewInitiativeReferral;
